<template>
  <div class="container-fluid" style="padding: 0px !important;">
  
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 messaging">
        <div style="display: flex; flex-direction: column; height:85vh">         
          <div id="scroll" class="msg_history" style="flex: 1">
            <template v-for="item in atendimento.messages">
              <div class="incoming_msg" v-if="item.type == 'you'" :key="item.id">
                <div class="incoming_msg_img">
                  <img src="https://www.xcontactcenter.com.br/teste/cdn/ciee/ICONEMARVIN.svg" style="width: 30px;" />
                </div>
                <div class="received_msg">
                  <div class="received_withd_msg">
                    <span class="time_date" style="margin-top: -2px">{{
                        item.agente
                    }}</span>                    
                    <pre v-if="!item.isLink && !item.isFile ">{{ item.text }}</pre>
                    <p v-if="item.isLink">
                      <span v-for="(part, index) in splitText(item.text)" :key="index">
                        <a v-if="part.isLink" target="_blank" :href="part.text">{{part.text}}</a>
                        <span v-else>{{part.text}}</span>
                      </span>
                    </p>                   
                    <p v-if="item.isFile">
                      <img v-if="item.mimetype.includes('image')" style="width: 150px; height: 150px;" :src="getUrl(item.path)"/>
                        <a v-if="item.mimetype.includes('text')" :href="getUrl(item.path)" target="_blank">
                         baixar documento
                        </a>
                        <audio v-if="item.mimetype.includes('audio')"                         
                            preload="none"
                            controls
                            controlsList="nodownload"
                          >
                        <source :src="getUrl(item.path)" :type="item.mimetype" />
                      </audio>

                    </p>                    
                    <span class="time_date">
                      {{ item.date | moment("HH:mm") }}
                      {{ item.date | moment("L") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="incoming_msg" v-if="item.type == ''" :key="item.id">
                <div class="incoming_msg_img">
                  <img src="https://www.xcontactcenter.com.br/teste/cdn/ciee/ICONEMARVIN.svg" style="width: 30px;" />
                </div>
                <div class="received_msg">
                  <div class="received_withd_msg">
                    <p v-if="!item.isLink" :inner-h-t-m-l="item.text" ></p>
                    <p v-if="item.isLink">
                      <span v-for="(part, index) in splitText(item.text)" :key="index">
                        <a v-if="part.isLink" target="_blank" :href="part.text">{{part.text}}</a>
                        <span v-else>{{part.text}}</span>
                      </span>
                    </p>      
                    <span class="time_date">
                      {{ item.date | moment("HH:mm") }}
                      {{ item.date | moment("L") }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="outgoing_msg" v-if="item.type == 'me'" :key="item.id">
                <div class="sent_msg">
                  <p :style="getColor()">{{ item.text }}</p>
                  <span class="time_date">
                    {{ item.date | moment("HH:mm") }}
                    {{ item.date | moment("L") }}
                  </span>
                </div>
              </div>
            </template>
          </div>

        </div>
        <div class="type_msg">
          <div class="container-fluid">
            <div style="display: flex; flex-direction: row" class="mt-2">
              <div style="flex: 0.2">
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <img src="https://img.icons8.com/cotton/30/000000/settings--v1.png" style="margin-bottom: 5px" />
                  </template>
                  <b-dropdown-item @click="exit()">
                    <img src="https://img.icons8.com/windows/25/000000/exit.png" />
                    <span>Encerrar atendimento</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <b-form-input id="input-2" v-model="text" placeholder="Mensagem..." style="flex: 4"
                v-on:keyup.enter="send()"></b-form-input>
              <button @click="send()" class="msg_send_btn" type="button" style="flex: 0.2">
                <img style="cursor: pointer" src="https://img.icons8.com/ios/25/000000/paper-plane.png" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import config from "../../config.json";
import VueSocketIO from "vue-socket.io";
import Vue from "vue";
import store from "../store";

const { mapState, mapActions } = createNamespacedHelpers("Atendimento");

export default {
  data() {
    return {
      text: "",
    };
  },
  created() {
    Vue.use(
      new VueSocketIO({
        debug: false,
        connection: config.enderecoCsa,
        vuex: {
          store,
          actionPrefix: "ws_",
          mutationPrefix: "ws_",
        },
      })
    );
    this.authenticate({ ...this.user });
    setTimeout(() => {
      this.sendMessage(`${this.user.nome}`);
    }, 500);
    //this.getState();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      atendimento: (state) => state.atendimento,
    }),
    messages: {
      get() {
        console.log("passou aqui");
        return this.atendimento.messages;
      },
    },
  },

  watch: {
    messages() {
      setTimeout(() => {
        var container = this.$el.querySelector("#scroll");
        container.scrollTop = container.scrollHeight;
      }, 500);

      this.setState();
      if (this.atendimento.lastEvent === "EncerrarAtendimento") {
        setTimeout(() => {
          localStorage.clear();
          this.removeState();
          this.$router.push("/");
        }, 30000);
      }
    },
  },
  methods: {
    ...mapActions([
      "authenticate",
      "sendMessage",
      "setState",
      "getState",
      "removeState",
    ]),
    getColor() {
      return `background:${config.corPrimaria} !important`;
    },
    getUrl(path){
      return `http://csawebchat2.xcontactcenter.com.br${path}`
    },
    send() {
      this.sendMessage(this.text);
      this.text = "";
    },
    exit() {
      localStorage.clear();
      this.removeState();

      this.$router.push("/");
    },
    splitText(text) {
      const regex = /(https?:\/\/[^\s]+)/g;
      const parts = text.split(regex);
      const matchedUrls = text.match(regex);

      let index = 0;
      const result = parts.map(part => {
        if (matchedUrls && part === matchedUrls[index]) {
          const url = matchedUrls[index];
          index++;
          return { isLink: true, text: url };
        } else {
          return { isLink: false, text: part };
        }
      });

    return result;
    },
    download(data) {
      // let aux = data.file.file_name.split(".");
      // let ext = aux[1];

      var FileSaver = require("file-saver");
      var file = new File([data.file.file], data.file.file_name, {
        type: "image/png",
      });
      console.log(file);
      FileSaver.saveAs(file, data.file.file_name);
      // fetch(`data:application/${ext};base64`, +data.file.file)
      //   .then(function(resp) {
      //     return resp.blob();
      //   })
      //   .then(function(blob) {
      //     saveAS(blob);
      //   });
    },
  },
};
</script>